// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a214a073","239":"729dce08","453":"f1d68eda","667":"34a693c4"}[chunkId] + ".chunk.js";
};